/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReloadIcon = /*#__PURE__*/ createSvgIcon(
  'ReloadIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 16c-1.667 0-3.083-.583-4.25-1.75C4.583 13.083 4 11.667 4 10c0-1.667.583-3.083 1.75-4.25C6.917 4.583 8.333 4 10 4c.903 0 1.74.188 2.51.563.771.375 1.434.875 1.99 1.5V4.75c0-.213.072-.39.214-.534A.72.72 0 0115.246 4c.21 0 .39.072.535.216A.72.72 0 0116 4.75v3.5c0 .213-.072.39-.216.534A.726.726 0 0115.25 9h-3.5a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h1.98a4.439 4.439 0 00-1.584-1.458A4.359 4.359 0 0010 5.5c-1.25 0-2.313.438-3.188 1.313S5.5 8.75 5.5 10c0 1.25.438 2.313 1.313 3.188C7.688 14.062 8.75 14.5 10 14.5c1.042 0 1.958-.316 2.75-.948a4.408 4.408 0 001.563-2.385.785.785 0 01.343-.459.79.79 0 01.553-.125.733.733 0 01.5.282c.124.16.166.336.124.53a5.922 5.922 0 01-2.083 3.303C12.68 15.566 11.43 16 10 16z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ReloadIcon;
